import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createModality } from "../../../../services/modality";
import { Speciality } from "../../../../interfaces/speciality";
import { useEffect, useState } from "react";
import { getSpecialities, getSpecialityOptions } from "../../../../services/speciality";
import { genderOptions } from "../../../../interfaces/modality";

interface AdminModalityNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminModalityNew(props: AdminModalityNewProps) {
    const [specialities, setSpecialities] = useState<Speciality[]>([]);

    useEffect(() => {
        getSpecialityOptions()
            .then(response => {
                setSpecialities(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            speciality_id: event.target.speciality_id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            gender: event.target.gender.value,
            distance: event.target.distance.value,
            boat: event.target.boat.value
        }
        createModality(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-modality-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_modality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="speciality_id">
                            <Form.Label aria-required="true">{ t("speciality") }</Form.Label>
                            <Form.Select aria-label={ t("speciality") } required>
                                <option value="">{ t("select_speciality") }</option>
                                { specialities.map((s: Speciality) => {
                                    return <option key={ 'speciality-' + s.id } value={ s.id }>{ s.name }</option>;
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="gender">
                            <Form.Label aria-required="true">{ t("gender") }</Form.Label>
                            <Form.Select aria-label={ t("gender") } required>
                                <option value="">{ t("select_gender") }</option>
                                { genderOptions.map((g: any) => {
                                    return <option key={ 'gender-' + g.value } value={ g.value }>{ t(g.label) }</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="distance">
                            <Form.Label aria-required="true">{ t("distance") }</Form.Label>
                            <Form.Control type="number" name="distance" defaultValue={ 0 }/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="boat">
                            <Form.Label aria-required="true">{ t("boat") }</Form.Label>
                            <Form.Control type="text" name="boat" required maxLength={ 50 } />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
